export default {
  calendar: 'calendar',
  there_is_no_events_at_this_day: 'there is no events at this day',
  event:'event',
  events:'events'

}
